import {
  TypographyElement,
  Col,
  Icon,
  Skeleton,
  Icons
} from 'UI'
import Text from './text.json'
import style from './style'
import { createUseStyles } from 'react-jss'

const useStyle = createUseStyles(style)

export default ({ numberOfCourses, selectedCategory, allCoursesCategory, loadingCourses }) => {
  const { iconClass, ResultInfos } = useStyle()
  return (
    <>
      <Col grid={12}>
        <TypographyElement
          variant='heading1'
          spacing='63px 0 4px 0'
          spacingTablet='16px 0 5px 0'
          spacingMobile='16px 0 5px 0'
          Component='h1'
          dataTest={selectedCategory.Id === allCoursesCategory.Id ? 'all-courses-title' : 'category-title'}
        >
          Formations {selectedCategory.Id === allCoursesCategory.Id ? Text.allCourses : selectedCategory?.Name}
        </TypographyElement>
        <TypographyElement spacing='16px 0 13px 0'>
          {selectedCategory.Introduction ? selectedCategory.Introduction : Text.defaultIntroduction}
        </TypographyElement>
      </Col>
      <Col grid={12}>
        {
          loadingCourses
            ? (
              <div className={ResultInfos}>
                <Skeleton lines={1} width='15%' height={30} heightTablet='24px !important' heightMobile='24px !important' />
              </div>
              )
            : (
              <div className={ResultInfos}>
                <Icon iconName={Icons.video} style={iconClass} />
                <TypographyElement
                  Component='p'
                  variant='body1'
                >
                  {`${numberOfCourses} ${Text.courses}`}
                </TypographyElement>
              </div>
              )
        }
      </Col>
    </>
  )
}
